export const SDK_KEYBOARD_MOUSE_TYPE = {
  keyboard: {
    beiyingDefault: 0, // 贝盈默认键盘 @bytech/web-hid-sdk
    beiyingMachine: 1, // 贝盈机甲键盘 @bytech/web-sdk-machine
  },
};
